import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: 'index',
	},
	{
		path: '/',
		name: 'defaultLayout',
		component: resolve => require(['@/views/Home'], resolve),
		meta: { title: 'GMQM私有云', icon: 'el-icon-monitor' },
		children: [
			{
				path: '/_gmqm/check/craft/tech',
				name: 'CraftView',
				component: () => import('../views/CheckManage/CraftInfo.vue'),
				meta: {
					title: '检测管理-工单工艺信息',
				},
			},
			{
				path: '/_gmqm/defect_filter/craft/tech',
				name: 'DefectFilterStat',
				component: () => import('../views/DefectFilter/CraftInfo.vue'),
				meta: {
					title: '缺陷筛查-工单工艺信息',
				},
			},
			{
				path: '/_gmqm/user/changePassword',
				name: 'changePassword',
				component: () => import('../views/SystemManage/User/password.vue'),
				meta: {
					title: '修改密码',
				},
			},
			{
				path: '/_gmqm/systeminfo',
				name: 'systemInfo',
				component: () => import('../views/SystemManage/SystemInfo.vue'),
				meta: {
					title: '系统信息',
				},
			},

			{
				path: '/_gmqm/product/import',
				name: 'productImport',
				component: () => import('../views/Plan/ProductImport.vue'),
				meta: {
					title: '导入产品数据',
				},
			},

			{
				path: '/_gmqm/joborder/import',
				name: 'joborderImport',
				component: () => import('../views/Plan/JobOrderImport.vue'),
				meta: {
					title: '导入工单数据',
				},
			},
		],
	},
	{
		path: '/control/stat/defect/view',
		name: 'ControlMonitorDefectStatisticalView',
		component: () => import('../views/ControlMonitor/DefectStatView.vue'),
		meta: {
			title: '统计报表',
		},
	},
	{
		path: '/control/stat/other',
		name: 'ControlMonitorOtherStat',
		component: () => import('../views/ControlMonitor/OtherStatOrders.vue'),
		meta: {
			title: '生产信息统计',
		},
	},
	{
		path: '/report/defect',
		name: 'defect_report',
		component: () => import('../views/Report/DefectReport/Index.vue'),
		meta: {
			title: '缺陷报表',
		},
	},
	{
		path: '/control/stat/other/report',
		name: 'ControlMonitorOtherReport',
		component: () => import('../views/ControlMonitor/OtherStatReport.vue'),
		meta: {
			title: '其他统计',
		},
	},
	{
		path: '/browser',
		name: 'Browser',
		component: () => import('../components/browser2/Index.vue'),
		meta: {
			title: '缺陷浏览器',
		},
	},
	// {
	// 	path: '/browser2',
	// 	name: 'Browser2',
	// 	component: () => import('../components/browser2/Index.vue'),
	// 	meta: {
	// 		title: '缺陷浏览器2',
	// 	},
	// },
	// {
	// 	path: '/defect/browser',
	// 	name: 'DefectBrowser',
	// 	component: () => import('../views/DefectFilter/Browser.vue'),
	// 	meta: {
	// 		title: '缺陷浏览器',
	// 	},
	// },
	// {
	// 	path: '/defect/browsercheckout',
	// 	name: 'DefectBrowsercheckout',
	// 	component: () => import('../views/CheckManage/Browser.vue'),
	// 	meta: {
	// 		title: '缺陷浏览器',
	// 	},
	// },
	{
		path: '/signIn',
		name: 'SignIn',
		component: () => import('../views/SignIn.vue'),
		meta: {
			title: 'GMQM-登录',
		},
	},
	{
		path: '/404',
		component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
	},
]

const router = new VueRouter({
	//mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior: () => ({ y: 0 }),
	routes,
})

export default router
